const serviceAgreementPageDetails = [
  { title: 'service_agreement__title1', info: 'service_agreement__info1' },
  { title: 'service_agreement__title2', info: 'service_agreement__info2' },
  {
    title: 'service_agreement__title3',
    info: 'service_agreement__info3',
    sub: [
      { title: 'service_agreement__title3_sub1', info: 'service_agreement__info3_sub1' },
      { title: 'service_agreement__title3_sub2', info: 'service_agreement__info3_sub2' },
    ],
  },
  { title: 'service_agreement__title4', info: 'service_agreement__info4' },
];

export default serviceAgreementPageDetails;
